import React from 'react';
import { PRINT_COLORS, PRINT_CHART_CONFIG } from './printTheme';

/**
 * Recharts <Legend content=... /> — forces black text and spacing below the X-axis.
 */
export default function PrintChartLegendContent({ payload }) {
  if (!payload || !payload.length) return null;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '22px',
        color: PRINT_COLORS.text,
        fontSize: PRINT_CHART_CONFIG.fontSize.legend,
        fontWeight: 600,
        paddingTop: 12,
        lineHeight: 1.2
      }}
    >
      {payload.map((entry, i) => {
        const isLine = entry.type === 'plainline' || entry.type === 'line';
        return (
          <span
            key={entry.value || i}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              color: PRINT_COLORS.text
            }}
          >
            {isLine ? (
              <span
                style={{
                  width: 18,
                  borderTop: `3px solid ${entry.color}`,
                  display: 'inline-block'
                }}
              />
            ) : (
              <span
                style={{
                  width: 9,
                  height: 9,
                  borderRadius: '50%',
                  background: entry.color,
                  display: 'inline-block'
                }}
              />
            )}
            <span style={{ color: PRINT_COLORS.text }}>{entry.value}</span>
          </span>
        );
      })}
    </div>
  );
}
